import { ISpinnerStyles, Spinner } from 'office-ui-fabric-react';
import * as React from 'react';

import { DiagnosticsActionStatus } from '../../models';
import { createStructuredSelector, mconnect } from '../../state/redux';
import { IStyledComponent, styledComponent } from '../../theme';
import { IComponentStateProps, IConnectedComponentProps } from '../../types';
import { getSafNodeSpinnerStyles } from '../intentGraph.styles';
import { dispatchFetchSafDiagnosticsAction } from '../reducers/dispatchers';
import {
  diagnosticsFormSelector,
  getNodeSelector,
  isDiagnosticActionInProgressSelector,
  sessionIdSelector
} from '../reducers/selectors.redux';

import { SafInlineDiagnostics } from './safInlineDiagnostics';

const mapStateToProps = createStructuredSelector({
  node: getNodeSelector,
  isDiagnosticsInProgress: isDiagnosticActionInProgressSelector,
  diagnosticsForm: diagnosticsFormSelector,
  sessionId: sessionIdSelector
});

const mapDispatchToProps = { dispatchFetchSafDiagnosticsAction };

type ISAFNodeProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  IStyledComponent<ISpinnerStyles> &
  IConnectedComponentProps &
  IComponentStateProps;

class SAFNodeC extends React.PureComponent<ISAFNodeProps> {
  public componentDidMount(): void {
    if (
      !!this.props.callbackHandlers.SafDiagnosticsRendered &&
      typeof this.props.callbackHandlers.SafDiagnosticsRendered === 'function'
    ) {
      this.props.dispatchFetchSafDiagnosticsAction(
        this.props.node,
        this.props.callbackHandlers.SafDiagnosticsRendered,
        this.props.callbackHandlers.LogHandler,
        this.props.diagnosticsForm
      );
    }
  }

  public render = (): React.ReactNode => {
    return (
      <>
        {this.props.node.get('diagnosticsActionStatus') === undefined ||
        this.props.node.get('diagnosticsActionStatus') === DiagnosticsActionStatus.FetchingDiagnosticsInProgress ? (
          <Spinner styles={getSafNodeSpinnerStyles(this.props)} />
        ) : (
          (this.props.callbackHandlers.GetSafDiagnosticComponent &&
            this.props.callbackHandlers.GetSafDiagnosticComponent(this.props.node.get('diagnosticUId'))) ||
          (this.props.diagnosticsForm.size > 0 && (
            <SafInlineDiagnostics
              stylesFunc={this.props.stylesFunc}
              callbackHandlers={this.props.callbackHandlers}
              nodeId={this.props.nodeId}
              uId={this.props.uId}
              dialogId={this.props.dialogId}
            />
          ))
        )}
      </>
    );
  };
}

export const SAFNode = mconnect(
  mapStateToProps,
  mapDispatchToProps
)(styledComponent(SAFNodeC, getSafNodeSpinnerStyles));
